import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/boolean-cell.scss';

Component('tr-grid-boolean-cell', {
  mixins: [baseMixin],

  properties: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.listenTo(this, {
      'tr-checkbox-field:change': this.handleChange.bind(this),
    });
  },

  preventClickEvent({ target }) {
    return this.editable && this.contains(target)
      && closest(target, 'tr-checkbox-field', this);
  },

  handleChange(event) {
    const value = event.detail.checked;
    this.value = value;
    this.namespacedTrigger('cellValueChange', {
      detail: { value },
      bubbles: true,
    });
  },
});
